import React, { useEffect, useState, useContext, useRef } from "react"
import CoachDirectoryDetails from "./CoachDirectoryDetails"
import CoachDirectoryFilters from "../../components/contacts/CoachDirectoryFilters"
import ContactsList from "../../components/contacts/ContactsList"
import ContactFilters from "../../components/contacts/ContactFilters"
import ContactInvite from "../../components/contacts/ContactInvite"
import ContactAdd from "../../components/contacts/ContactAdd"
import ConfirmContactInvite from "../../components/contacts/ConfirmContactInvite"
import ContactRequestFull from "../../components/contacts/ContactRequestFull"
import Loader from "../../components/ui/loader"
import MobilecoachDirectoryFilters from "../../components/contacts/MobileCoachDirectoryFilters"
import MobileContactsFilters from "../../components/contacts/MobileContactsFilters"
import useLoading from "../../hooks/useLoading"
import useScrollToTop from "../../hooks/useScrollToTop"
import { Badge } from "../../components/ui/badge"
import { Button } from "../../components/ui/button"
import { CoachCard } from "../../models/public.interface"
import { ContactRequests } from "../../api/app.service"
import { NotificationRequests } from "../../api/app.service"
import { NotificationCtx } from "../../context/notificationContext"
import {
  SvgFilter,
  SvgSearch,
  SvgUserPlus,
  SvgFilledInformationCircle,
} from "../../components/icons/"
import { UserCtx } from "../../context/userContext"
import { useSearchParams } from "react-router-dom"
import { useToast } from "../../hooks/useToast"

const CoachContacts: React.FC<{
  setShowContactProfile: (show: boolean) => void
  coach: CoachCard
  onSendCoaches: (coaches: any[]) => void
}> = ({ setShowContactProfile, coach, onSendCoaches }) => {
  const {
    coach_public_profile_id,
    coach_profile_id,
    user_id,
    endpoint_slug,
    last_name,
    first_name,
    description,
    tags,
    avatar_url,
    max_end_date,
    updated_at,
    subscription_promo_codes,
    email,
  } = coach
  const [searchParams] = useSearchParams()
  const receivedInvites = searchParams.get("received_invites")
  const [contacts, setContacts] = useState<any>([])
  const [, setSelectedContact] = useState<any>(null)
  const [showAllContacts, setShowAllContacts] = useState<boolean>(true)
  const [showZoeeLeads, setShowZoeeLeads] = useState<boolean>(false)
  const [showCoach, setShowCoach] = useState<boolean>(false)
  const [showReceivedInvites, setShowReceivedInvites] = useState<boolean>(false)
  const [showInvited, setShowInvited] = useState<boolean>(false)
  const [showCoachDirectory, setShowCoachDirectory] = useState<boolean>(false)
  const [searchValue, setSearchValue] = useState<string>("")
  const [searchContactValue, setSearchContactValue] = useState<string>("")
  const [showInviteModal, setShowInviteModal] = useState<boolean>(false)
  const [showProspectModal, setShowProspectModal] = useState<boolean>(false)
  const [showConfirmInviteModal, setShowConfirmInviteModal] =
    useState<boolean>(false)
  const [contactRequestFull, setContactRequestFull] = useState<any>({
    show: false,
    contact: null,
    variant: null,
  })
  const [coaches, setCoaches] = useState<any[]>([])
  const { user } = useContext(UserCtx)
  const { toast } = useToast()
  const { startLoading, stopLoading } = useLoading()
  const [invites, setInvites] = useState<any>([{ email: "" }])
  const [prospect, setProspect] = useState<any>({
    firstName: "",
    lastName: "",
    email: "",
  })
  const [sortedCoaches, setSortedCoaches] = useState<any[]>([])
  const [selectedSort, setSelectedSort] = useState<string>("none")
  const [selectedFilter, setSelectedFilter] = useState<string>("active")
  const [showContactsMobileListView, setShowContactsMobileListView] =
    useState<boolean>(true)
  const [showMobileFilters, setShowMobileFilters] = useState<boolean>(false)
  const { contactsNotifications, setContactsNotifications } =
    useContext(NotificationCtx)
  const [loadingContacts, setLoadingContacts] = useState<boolean>(false)
  const [, setSortedContacts] = useState([])
  const originalContacts = useRef<any[]>([])
  const [show, setshow] = useState<boolean>(false)
  const [showCoachDirectoryDetails, setShowCoachDirectoryDetails] =
    useState<boolean>(false)

  const [showCoachDirectoryTab, setShowCoachDirectoryTab] = useState<boolean>(
    localStorage.getItem("showCoachDirectory") === "true"
  )

  useEffect(() => {
    if (showCoachDirectoryTab) {
      setShowAllContacts(false)
      setShowZoeeLeads(false)
      setShowCoach(false)
      setShowReceivedInvites(false)
      setShowInvited(false)
      setShowCoachDirectory(true)
    }
  }, [showCoachDirectoryTab])

  useEffect(() => {
    if (showCoachDirectoryTab) {
      localStorage.removeItem("showCoachDirectory")
    }
  }, [setShowCoachDirectoryTab])

  const handleSendCoaches = (coaches: any[]) => {
    setCoaches(coaches)
    onSendCoaches(coaches)
  }

  useEffect(() => {
    if (originalContacts.current.length === 0) {
      originalContacts.current = contacts
    }
  }, [contacts])

  useEffect(() => {
    if (receivedInvites) {
      setShowAllContacts(false)
      setShowZoeeLeads(false)
      setShowCoach(false)
      setShowReceivedInvites(true)
      setShowInvited(false)
      setShowCoachDirectory(false)
    }
  }, [receivedInvites])

  const showComponent = (callback: any, sortFn: any = null) => {
    if (sortFn) {
      const sorted = sortFn(contacts)
      setSortedContacts(sorted)
    } else {
      setSortedContacts([])
    }
    setShowAllContacts(false)
    setShowZoeeLeads(false)
    setShowCoach(false)
    setShowReceivedInvites(false)
    setShowInvited(false)
    setShowCoachDirectory(false)
    callback(true)
  }

  const filterContacts = (
    contacts: any[],
    type:
      | "connected"
      | "leads"
      | "prospect"
      | "requested"
      | "invited"
      | "coachdirectory"
      | "all"
      | "coach"
      | "member",
    searchValue: string,
    searchContactValue: string
  ) => {
    return contacts.filter((contact) => {
      const firstName = contact.first_name
        ? contact.first_name.toLowerCase()
        : ""
      const lastName = contact.last_name ? contact.last_name.toLowerCase() : ""
      const nameMatch =
        firstName.includes(searchValue.toLowerCase()) ||
        lastName.includes(searchValue.toLowerCase())

      const contactMatch =
        searchContactValue.trim() ===
          firstName.includes(searchContactValue.toLowerCase()) ||
        lastName.includes(searchContactValue.toLowerCase())

      switch (type) {
        case "all":
          return nameMatch || contactMatch
        case "connected":
          return (
            (contact.contact_type === "connected" ||
              contact.contact_type === "prospect") &&
            (nameMatch || contactMatch)
          )
        case "leads":
          return contact.status === "zoee lead" && (nameMatch || contactMatch)
        case "coach":
          return (
            contact.contact_type === "connected" &&
            contact.profile_type === "coach" &&
            (nameMatch || contactMatch)
          )
        case "member":
          return (
            contact.contact_type === "connected" &&
            contact.profile_type === "member" &&
            (nameMatch || contactMatch)
          )
        case "prospect":
          return (
            contact.contact_type === "connected" &&
            contact.profile_type === "prospect" &&
            (nameMatch || contactMatch)
          )
        case "requested":
          return (
            contact.contact_type === "requested" && (nameMatch || contactMatch)
          )
        case "invited":
          return (
            contact.contact_type === "invited" && (nameMatch || contactMatch)
          )
        case "coachdirectory":
          return (
            contact.contact_type === "connected" &&
            contact.profile_type === "coach" &&
            nameMatch
          )
        default:
          return nameMatch || contactMatch
      }
    })
  }

  const updateSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }

  const updateContactSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchValue = e.target.value
    setSearchContactValue(newSearchValue)

    if (newSearchValue === "") {
      setContacts([...originalContacts.current])
    } else {
      const filteredContacts = originalContacts.current.filter((contact: any) =>
        contact.contact_name
          ?.toLowerCase()
          .includes(newSearchValue.toLowerCase())
      )
      setContacts(filteredContacts)
    }
  }

  const getContacts = () => {
    // mode is coach -> activeProfileId will be of a coach,
    if (user?.coachProfile || user?.memberProfile) {
      setLoadingContacts(true)
      ContactRequests.getContactList({
        profile_id: user.activeProfileId,
        profile_type: user.activeProfile,
      })
        .then((data) => {
          setContacts(data.contact_list)
          setLoadingContacts(false)
          stopLoading()
        })
        .catch((ex) => {
          console.error(ex)
          setLoadingContacts(false)
          toast.error(ex.response.data.message)
        })
    }
  }

  const acceptContactRequest = (contact: any) => {
    if (user?.coachProfile || user?.memberProfile) {
      startLoading()
      ContactRequests.acceptContactRequest({
        profile_id: user.activeProfileId,
        profile_type: user.activeProfile,
        request_id: parseInt(contact.request_id),
        request_by_profile_id: parseInt(contact.request_by_profile_id),
        user_environment: process.env.REACT_APP_USER_ENVIRONMENT || "",
      })
        .then(() => {
          getContacts()
          toast.success("Request accepted!")
        })
        .catch((ex) => {
          console.error(ex)
          toast.error(ex.response.data.message)
          stopLoading()
        })
    }
  }

  const denyContactRequest = (contact: any) => {
    if (user?.coachProfile) {
      startLoading()
      ContactRequests.denyContactRequest({
        request_id: parseInt(contact.request_id),
      })
        .then(() => {
          getContacts()
          toast.success("Request denied!")
        })
        .catch((ex) => {
          console.error(ex)
          toast.error(ex.response.data.message)
          stopLoading()
        })
    }
  }

  const revokeContactRequest = (contact: any) => {
    if (user?.coachProfile || user?.memberProfile) {
      startLoading()
      ContactRequests.revokeContactRequest({
        request_id: parseInt(contact.request_id),
        request_email: contact.contact_name,
        request_by_profile_id: user.activeProfileId,
      })
        .then(() => {
          getContacts()
          toast.success("Invite revoked!")
        })
        .catch((ex) => {
          console.error(ex)
          toast.error(ex.response.data.message)
          stopLoading()
        })
    }
  }

  const resendContactRequest = (contact: any) => {
    if (user?.coachProfile || user?.memberProfile) {
      startLoading()
      ContactRequests.resendContactRequest({
        request_id: parseInt(contact.request_id),
        request_email: contact.contact_name,
        request_by_profile_id: user.activeProfileId,
      })
        .then(() => {
          getContacts()
          toast.success("Invite resent!")
        })
        .catch((ex) => {
          console.error(ex)
          toast.error(ex.response.data.message)
          stopLoading()
        })
    }
  }

  const markContactNotificationsAsRead = () => {
    if (contactsNotifications.length === 0) return

    const unreadNotificationIds = contactsNotifications
      .filter((n: any) => n.viewed === 0)
      .map((n: any) => n.id)
    NotificationRequests.markRead({
      profile_id: user.activeProfileId,
      notification_ids: unreadNotificationIds,
    })
      .then(() => {
        const allReadContactsNotifications = contactsNotifications.map(
          (n: any) => {
            n.viewed = true
            return n
          }
        )
        setContactsNotifications(allReadContactsNotifications)
      })
      .catch((ex) => {
        console.error(ex)
        toast.error(ex.response.data.message)
      })
  }

  useEffect(() => {
    getContacts()
  }, [])

  useScrollToTop()

  useEffect(() => {
    if (!showCoachDirectory) {
      localStorage.removeItem("coaches")
    }
  }, [showCoachDirectory])

  return (
    <>
      {showInviteModal && (
        <ContactInvite
          setShowInviteModal={setShowInviteModal}
          invites={invites}
          setInvites={setInvites}
          setShowConfirmInviteModal={setShowConfirmInviteModal}
          invitedContacts={filterContacts(
            contacts,
            "invited",
            searchValue,
            searchContactValue
          )}
        />
      )}

      {showConfirmInviteModal && (
        <ConfirmContactInvite
          setShowConfirmInviteModal={setShowConfirmInviteModal}
          invites={invites}
          contacts={contacts}
          setInvites={setInvites}
        />
      )}

      {showProspectModal && (
        <ContactAdd
          prospect={prospect}
          setProspect={setProspect}
          contacts={contacts}
          setShowProspectModal={setShowProspectModal}
          getContacts={getContacts}
        />
      )}

      {contactRequestFull.show ? (
        <ContactRequestFull
          setContactRequestFull={setContactRequestFull}
          contactRequestFull={contactRequestFull}
          acceptContactRequest={acceptContactRequest}
          denyContactRequest={denyContactRequest}
          resendContactRequest={resendContactRequest}
          revokeContactRequest={revokeContactRequest}
        />
      ) : (
        <section className="">
          {/* MOBILE */}
          <div className="bg-[#fcfcfc] md:hidden text-center">
            <div className="mx-auto mb-[12px] mt-[8px] flex w-full max-w-[600px] items-center justify-center gap-[16px] px-[20px]">
              <h1
                className="text-[36px] font-bold"
                data-cy="coach-contacts-heading"
              >
                Contacts
              </h1>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setShowMobileFilters(() => !showMobileFilters)}
              >
                <SvgFilter />
              </Button>
            </div>
            <Button
              className="md:hidden mb-4"
              onClick={() => setShowInviteModal(!showInviteModal)}
            >
              <SvgUserPlus />
              Invite a Contact
            </Button>
          </div>

          {showMobileFilters && !showCoachDirectory && (
            <MobileContactsFilters
              selectedSort={selectedSort}
              setSelectedSort={setSelectedSort}
              setShowMobileFilters={setShowMobileFilters}
              showComponent={showComponent}
              setShowReceivedInvites={setShowReceivedInvites}
              setShowInvited={setShowInvited}
              setShowZoeeLeads={setShowZoeeLeads}
              setShowCoach={setShowCoach}
              setShowAllContacts={setShowAllContacts}
              showReceivedInvites={showReceivedInvites}
              showCoachDirectory={showCoachDirectory}
              setShowCoachDirectory={setShowCoachDirectory}
              showInvited={showInvited}
              showZoeeLeads={showZoeeLeads}
              showCoach={showCoach}
              showAllContacts={showAllContacts}
              contacts={contacts}
              setContacts={setContacts}
              filterReceivedInvites={filterContacts(
                contacts,
                "requested",
                searchValue,
                searchContactValue
              )}
              filterInvited={filterContacts(
                contacts,
                "invited",
                searchValue,
                searchContactValue
              )}
            />
          )}
          {showMobileFilters && showCoachDirectory && (
            <>
              <MobilecoachDirectoryFilters
                selectedSort={selectedSort}
                selectedFilter={selectedFilter}
                setSelectedSort={setSelectedSort}
                setSelectedFilter={setSelectedFilter}
                coaches={coaches}
                setCoaches={setCoaches}
                contacts={contacts}
                showComponent={showComponent}
                setShowCoach={setShowCoach}
                setShowMobileFilters={setShowMobileFilters}
                setShowAllContacts={setShowAllContacts}
                showAllContacts={showAllContacts}
                showCoach={showCoach}
                setShowZoeeLeads={setShowZoeeLeads}
                showZoeeLeads={showZoeeLeads}
                setShowReceivedInvites={setShowReceivedInvites}
                showReceivedInvites={showReceivedInvites}
                filterReceivedInvites={filterContacts(
                  contacts,
                  "requested",
                  searchValue,
                  searchContactValue
                )}
                setShowInvited={setShowInvited}
                showInvited={showInvited}
                filterInvited={filterContacts(
                  contacts,
                  "invited",
                  searchValue,
                  searchContactValue
                )}
                setShowCoachDirectory={setShowCoachDirectory}
                showCoachDirectory={showCoachDirectory}
              />
            </>
          )}

          {/* DESKTOP */}
          <div
            className={`hidden mt-0 w-full max-w-screen-lg md:flex flex-col bg-[#fcfcfc] mx-auto z-[200] p-4`}
          >
            <div className="mb-[24px] flex w-full flex-col items-center justify-between border-b-[1px] border-[#EBEBEB] pb-[24px] md:flex-row">
              <h1
                className="text-[36px] font-bold"
                data-cy="coach-contacts-heading"
              >
                Contacts
              </h1>
              <div className="flex w-[335px] items-center justify-between sm:w-auto sm:gap-[12px]">
                {showCoachDirectory && (
                  <div className="search-input w-[189px] sm:w-[260px]">
                    <input
                      type="text"
                      placeholder="Search Coach"
                      onChange={updateSearchValue}
                      value={searchValue}
                    />
                    <SvgSearch className="absolute left-3 top-1/2 -translate-y-1/2" />
                  </div>
                )}
                {!showCoachDirectory && (
                  <div className="search-input w-[189px] sm:w-[260px]">
                    <input
                      type="text"
                      value={searchContactValue}
                      onChange={updateContactSearchValue}
                      placeholder="Search Contacts"
                    />
                    <SvgSearch className="absolute left-3 top-1/2 -translate-y-1/2" />
                  </div>
                )}
                <div className="ml-auto mr-2">
                  <Button onClick={() => setShowInviteModal(!showInviteModal)}>
                    <SvgUserPlus />
                    Invite a Contact
                  </Button>
                </div>
              </div>
            </div>
            <div className="flex w-full flex-col items-center justify-between md:flex-row">
              <div className="mb-[20px] flex w-[351px] items-center gap-2 overflow-x-auto pb-2 sm:w-auto md:mb-0">
                <Button
                  data-cy="coach-contacts-clients-tab"
                  variant={showAllContacts ? "utility" : "ghost"}
                  onClick={() => showComponent(setShowAllContacts)}
                >
                  My Clients
                </Button>
                <Button
                  variant={showCoach ? "utility" : "ghost"}
                  onClick={() => showComponent(setShowCoach)}
                >
                  My Coaches
                </Button>

                <Button
                  variant={showZoeeLeads ? "utility" : "ghost"}
                  onClick={() => showComponent(setShowZoeeLeads)}
                >
                  Leads
                </Button>

                <Button
                  variant={showReceivedInvites ? "utility" : "ghost"}
                  onClick={() => {
                    showComponent(setShowReceivedInvites)
                    markContactNotificationsAsRead()
                  }}
                >
                  Received Invites
                  {filterContacts(
                    contacts,
                    "requested",
                    searchValue,
                    searchContactValue
                  ).length > 0 && (
                    <Badge
                      variant="alert"
                      className="text-center px-2 h-5 w-5 -mt-5 -ml-3"
                    >
                      {
                        filterContacts(
                          contacts,
                          "requested",
                          searchValue,
                          searchContactValue
                        ).length
                      }
                    </Badge>
                  )}
                </Button>

                <Button
                  variant={showInvited ? "utility" : "ghost"}
                  onClick={() => showComponent(setShowInvited)}
                >
                  Sent Invites
                  {filterContacts(
                    contacts,
                    "invited",
                    searchValue,
                    searchContactValue
                  ).length > 0 && (
                    <Badge variant="alert" className="px-1 h-5 w-5 -mt-5 -ml-3">
                      {
                        filterContacts(
                          contacts,
                          "invited",
                          searchValue,
                          searchContactValue
                        ).length
                      }
                    </Badge>
                  )}
                </Button>
                <Button
                  variant={showCoachDirectory ? "utility" : "ghost"}
                  onClick={() => showComponent(setShowCoachDirectory)}
                >
                  Coach Directory
                </Button>
                {user.activeProfile === "coach" && (
                  <span onClick={() => setShowCoachDirectoryDetails(true)}>
                    <SvgFilledInformationCircle className="h-4 w-4 -mt-5 -ml-6" />
                  </span>
                )}
              </div>
              {!showInvited && !showCoachDirectory && (
                <ContactFilters
                  contacts={contacts}
                  setContacts={setContacts}
                  selectedSort={selectedSort}
                  selectedFilter={selectedFilter}
                  setSelectedSort={setSelectedSort}
                  setSelectedFilter={setSelectedFilter}
                />
              )}
              {showCoachDirectory && (
                <CoachDirectoryFilters
                  selectedSort={selectedSort}
                  selectedFilter={selectedFilter}
                  setSelectedSort={setSelectedSort}
                  setSelectedFilter={setSelectedFilter}
                  coaches={coaches}
                  setCoaches={setCoaches}
                  contacts={contacts}
                />
              )}
            </div>
          </div>

          {/* SHARED ELEMENTS FOR DESKTOP AND MOBILE */}
          {loadingContacts ? (
            <div className="mt-[24px] flex flex-col items-center gap-[12px]">
              <Loader />
              <h3 className="mb-[4px] text-center text-[16px] font-bold">
                Looking for your contacts...
              </h3>
            </div>
          ) : (
            <div className="mx-auto pt-[12px] max-w-screen-lg md:pt-[32px] md:flex md:justify-center">
              {" "}
              {/* shows member contacts, showAllContacts is misleading yet to rename the flag to showClients */}
              {showAllContacts && (
                <ContactsList
                  setInvites={setInvites}
                  setShowConfirmInviteModal={setShowConfirmInviteModal}
                  getContacts={getContacts}
                  contacts={filterContacts(
                    contacts,
                    "member",
                    searchValue,
                    searchContactValue
                  )}
                  searchValue={searchValue}
                  setSelectedContact={setSelectedContact}
                  setShowContactProfile={setShowContactProfile}
                  setShowInviteModal={setShowInviteModal}
                  type="all"
                  setContactRequestFull={setContactRequestFull}
                  acceptContactRequest={acceptContactRequest}
                  denyContactRequest={denyContactRequest}
                  revokeContactRequest={revokeContactRequest}
                  resendContactRequest={resendContactRequest}
                  showContactsMobileListView={showContactsMobileListView}
                  first_name={first_name}
                  last_name={last_name}
                  coach_public_profile_id={coach_public_profile_id}
                  coach_profile_id={coach_profile_id}
                  user_id={user_id}
                  endpoint_slug={endpoint_slug}
                  description={description}
                  tags={tags}
                  avatar_url={avatar_url}
                  max_end_date={max_end_date}
                  subscription_promo_codes={subscription_promo_codes}
                  updated_at={updated_at}
                  email={email}
                  onSendCoaches={handleSendCoaches}
                />
              )}
              {showZoeeLeads && (
                <ContactsList
                  setInvites={setInvites}
                  setShowConfirmInviteModal={setShowConfirmInviteModal}
                  getContacts={getContacts}
                  contacts={filterContacts(
                    contacts,
                    "leads",
                    searchValue,
                    searchContactValue
                  )}
                  searchValue={searchValue}
                  setSelectedContact={setSelectedContact}
                  setShowContactProfile={setShowContactProfile}
                  setShowInviteModal={setShowInviteModal}
                  type="leads"
                  setContactRequestFull={setContactRequestFull}
                  acceptContactRequest={acceptContactRequest}
                  denyContactRequest={denyContactRequest}
                  revokeContactRequest={revokeContactRequest}
                  resendContactRequest={resendContactRequest}
                  showContactsMobileListView={showContactsMobileListView}
                  first_name={first_name}
                  last_name={last_name}
                  coach_public_profile_id={coach_public_profile_id}
                  coach_profile_id={coach_profile_id}
                  user_id={user_id}
                  endpoint_slug={endpoint_slug}
                  description={description}
                  tags={tags}
                  avatar_url={avatar_url}
                  max_end_date={max_end_date}
                  subscription_promo_codes={subscription_promo_codes}
                  updated_at={updated_at}
                  email={email}
                  onSendCoaches={handleSendCoaches}
                />
              )}
              {/* shows coach contacts, showCoach is misleading yet to rename the flag to showCoaches*/}
              {showCoach && (
                <ContactsList
                  setInvites={setInvites}
                  setShowConfirmInviteModal={setShowConfirmInviteModal}
                  getContacts={getContacts}
                  contacts={filterContacts(
                    contacts,
                    "coach",
                    searchValue,
                    searchContactValue
                  )}
                  searchValue={searchValue}
                  setSelectedContact={setSelectedContact}
                  setShowContactProfile={setShowContactProfile}
                  setShowInviteModal={setShowInviteModal}
                  type="coach"
                  setContactRequestFull={setContactRequestFull}
                  acceptContactRequest={acceptContactRequest}
                  denyContactRequest={denyContactRequest}
                  revokeContactRequest={revokeContactRequest}
                  resendContactRequest={resendContactRequest}
                  showContactsMobileListView={showContactsMobileListView}
                  first_name={first_name}
                  last_name={last_name}
                  coach_public_profile_id={coach_public_profile_id}
                  coach_profile_id={coach_profile_id}
                  user_id={user_id}
                  endpoint_slug={endpoint_slug}
                  description={description}
                  tags={tags}
                  avatar_url={avatar_url}
                  max_end_date={max_end_date}
                  subscription_promo_codes={subscription_promo_codes}
                  updated_at={updated_at}
                  email={email}
                  onSendCoaches={handleSendCoaches}
                />
              )}
              {showReceivedInvites && (
                <ContactsList
                  setInvites={setInvites}
                  setShowConfirmInviteModal={setShowConfirmInviteModal}
                  getContacts={getContacts}
                  contacts={filterContacts(
                    contacts,
                    "requested",
                    searchValue,
                    searchContactValue
                  )}
                  searchValue={searchValue}
                  setSelectedContact={setSelectedContact}
                  setShowContactProfile={setShowContactProfile}
                  setShowInviteModal={setShowInviteModal}
                  type="requested"
                  setContactRequestFull={setContactRequestFull}
                  acceptContactRequest={acceptContactRequest}
                  denyContactRequest={denyContactRequest}
                  revokeContactRequest={revokeContactRequest}
                  resendContactRequest={resendContactRequest}
                  showContactsMobileListView={showContactsMobileListView}
                  first_name={first_name}
                  last_name={last_name}
                  coach_public_profile_id={coach_public_profile_id}
                  coach_profile_id={coach_profile_id}
                  user_id={user_id}
                  endpoint_slug={endpoint_slug}
                  description={description}
                  tags={tags}
                  avatar_url={avatar_url}
                  max_end_date={max_end_date}
                  subscription_promo_codes={subscription_promo_codes}
                  updated_at={updated_at}
                  email={email}
                  onSendCoaches={handleSendCoaches}
                />
              )}
              {showInvited && (
                <ContactsList
                  setInvites={setInvites}
                  setShowConfirmInviteModal={setShowConfirmInviteModal}
                  getContacts={getContacts}
                  contacts={filterContacts(
                    contacts,
                    "invited",
                    searchValue,
                    searchContactValue
                  )}
                  searchValue={searchValue}
                  setSelectedContact={setSelectedContact}
                  setShowContactProfile={setShowContactProfile}
                  setShowInviteModal={setShowInviteModal}
                  type="invited"
                  setContactRequestFull={setContactRequestFull}
                  acceptContactRequest={acceptContactRequest}
                  denyContactRequest={denyContactRequest}
                  revokeContactRequest={revokeContactRequest}
                  resendContactRequest={resendContactRequest}
                  showContactsMobileListView={showContactsMobileListView}
                  first_name={first_name}
                  last_name={last_name}
                  coach_public_profile_id={coach_public_profile_id}
                  coach_profile_id={coach_profile_id}
                  user_id={user_id}
                  endpoint_slug={endpoint_slug}
                  description={description}
                  tags={tags}
                  avatar_url={avatar_url}
                  max_end_date={max_end_date}
                  subscription_promo_codes={subscription_promo_codes}
                  updated_at={updated_at}
                  email={email}
                  onSendCoaches={handleSendCoaches}
                />
              )}
              {showCoachDirectory && (
                <ContactsList
                  setInvites={setInvites}
                  setShowConfirmInviteModal={setShowConfirmInviteModal}
                  getContacts={getContacts}
                  contacts={contacts}
                  searchValue={searchValue}
                  coachesSorted={coaches}
                  setSelectedContact={setSelectedContact}
                  setShowContactProfile={setShowContactProfile}
                  setShowInviteModal={setShowInviteModal}
                  type="coachdirectory"
                  setContactRequestFull={setContactRequestFull}
                  acceptContactRequest={acceptContactRequest}
                  denyContactRequest={denyContactRequest}
                  revokeContactRequest={revokeContactRequest}
                  resendContactRequest={resendContactRequest}
                  showContactsMobileListView={showContactsMobileListView}
                  first_name={first_name}
                  last_name={last_name}
                  coach_public_profile_id={coach_public_profile_id}
                  coach_profile_id={coach_profile_id}
                  user_id={user_id}
                  endpoint_slug={endpoint_slug}
                  description={description}
                  tags={tags}
                  avatar_url={avatar_url}
                  max_end_date={max_end_date}
                  subscription_promo_codes={subscription_promo_codes}
                  updated_at={updated_at}
                  email={email}
                  onSendCoaches={handleSendCoaches}
                />
              )}
            </div>
          )}
          <div className="md:h-[300px] md:w-full"></div>
        </section>
      )}
      {showCoachDirectoryDetails && (
        <CoachDirectoryDetails
          setShowCoachDirectoryDetails={setShowCoachDirectoryDetails}
        />
      )}
    </>
  )
}

export default CoachContacts
